import { Button } from 'antd';
import { useState } from 'react';
import { Link } from 'react-router-dom';

import { trackLinkClick } from '../../analytics/mixpanel';
import { PrivacyPolicy, TermsAndConditions } from '..';
import Navbar from '../Navbar/Navbar';

function ErrorPage() {
  const [showTerms, setShowTerms] = useState(false);
  const [showPolicy, setShowPolicy] = useState(false);
  const product = localStorage.getItem('product');

  return (
    <>
      <Navbar />
      <section className='error-section'>
        <div className='error-content'>
          <h1 className='mb-16'>Oops! Something went wrong</h1>
          <p className='mb-16'>
            Please try again or contact{' '}
            <a className='error-email' href='mailto:team@mikelegal.com'>
              team@mikelegal.com
            </a>{' '}
            if the issue persists.
          </p>
          <Link
            to={
              (product === 'doccompare' && '/doccompare') || (product === 'docchat' && '/docchat')
            }
          >
            <Button type='primary' size='large' className='goto-btn'>
              Go to Home
            </Button>
          </Link>
        </div>
        <footer className='error-footer'>
          <div className='footer-content'>
            <p>
              <span
                className='mr-16'
                role='button'
                onClick={() => {
                  trackLinkClick({ type: 'Terms and Conditions' });
                  setShowTerms(true);
                }}
              >
                Terms and Conditions
              </span>
              <span
                className='ml-16'
                role='button'
                onClick={() => {
                  trackLinkClick({ type: 'Privacy Policy' });
                  setShowPolicy(true);
                }}
              >
                Privacy Policy
              </span>
            </p>
            <p>&#169; 2023 MikeLegal - All Rights Reserved</p>
          </div>
        </footer>
        {showTerms && <TermsAndConditions open={showTerms} setShowTerms={setShowTerms} />}
        {showPolicy && <PrivacyPolicy open={showPolicy} setShowPolicy={setShowPolicy} />}
      </section>
    </>
  );
}

export default ErrorPage;
